import React from 'react';
import { IQuestionnaireItemDecimalComponent } from '../../modules/unsw-fhir/Questionnaire';
import Conditionals from '../Fields/Conditional/Conditionals';
import { generateSimpleEnableWhenPredicate } from '../../modules/unsw-fhir/QuestionnaireResponse/helpers';
import DecimalField from '../Fields/NumberField';
import { QuestionnaireItemValidator } from '../../modules/unsw-fhir-questionnaire/Utilities/Validators';
import {
  getPromptTexts,
  getSupportingLinkUris,
  getMinValue,
  getMaxValue,
} from '../../modules/unsw-fhir/Questionnaire/extensions';
import { useModal } from '../../modules/unsw-modals';

const QuestionnaireDecimalItem = (
  props: IQuestionnaireItemDecimalComponent,
) => {
  const { enableWhen, ...rest } = props;
  const prompts = getPromptTexts(props);
  const supportLinks = getSupportingLinkUris(props);
  const min = getMinValue(props);
  const max = getMaxValue(props);
  const { openSupportingLinks } = useModal();

  return enableWhen ? (
    <Conditionals
      question={props.linkId}
      enableWhens={enableWhen.map(ew => ({
        when: ew.question,
        is: generateSimpleEnableWhenPredicate(ew),
      }))}>
      {({ enabled }) => (
        <DecimalField
          informationText={prompts}
          name={props.linkId}
          supportingLink={
            supportLinks.length !== 0
              ? () => openSupportingLinks(supportLinks)
              : undefined
          }
          validate={QuestionnaireItemValidator(props)}
          enabled={enabled}
          min={min}
          max={max}
          {...rest}
        />
      )}
    </Conditionals>
  ) : (
    <DecimalField
      informationText={prompts}
      name={props.linkId}
      supportingLink={
        supportLinks.length !== 0
          ? () => openSupportingLinks(supportLinks)
          : undefined
      }
      validate={QuestionnaireItemValidator(props)}
      min={min}
      max={max}
      {...rest}
    />
  );
};

export default QuestionnaireDecimalItem;
